document.addEventListener("DOMContentLoaded", () => {
  const menuBtn = document.querySelector("[data-menu-toggle]");
  const menu = document.querySelector("[data-mobile-menu]");
  if (menuBtn && menu) {
    menuBtn.addEventListener("click", () => {
      const open = menu.classList.toggle("is-open");
      menuBtn.setAttribute("aria-expanded", String(open));
    });
  }

  const logo = document.querySelector("[data-logo-3d]");
  if (logo && window.matchMedia("(pointer:fine)").matches) {
    let targetX = 0, targetY = 0, x = 0, y = 0;
    const stage = logo.closest(".logo-stage");
    stage?.addEventListener("pointermove", e => {
      const r = stage.getBoundingClientRect();
      targetY = ((e.clientX - r.left) / r.width - .5) * 18;
      targetX = ((e.clientY - r.top) / r.height - .5) * -8;
    });
    stage?.addEventListener("pointerleave", () => { targetX = 0; targetY = 0; });
    const tick = () => {
      x += (targetX - x) * .06; y += (targetY - y) * .06;
      logo.style.setProperty("--mx", `${x}deg`);
      logo.style.setProperty("--my", `${y}deg`);
      requestAnimationFrame(tick);
    };
    tick();
  }
});
document.addEventListener("DOMContentLoaded", () => {
  const gate = document.querySelector("[data-enter-gate]");
  const storefront = document.querySelector("[data-storefront]");
  const enter = document.querySelector("[data-enter]");
  const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  // The gate is session-based: visitors see ENTER once per browser session.
  if (gate && storefront) {
    const entered = sessionStorage.getItem("unbrkable_entered");
    if (entered === "1") {
      gate.remove();
      storefront.classList.add("is-entered");
      storefront.setAttribute("aria-hidden", "false");
    } else {
      document.body.classList.add("gate-active");
      enter?.addEventListener("click", () => {
        sessionStorage.setItem("unbrkable_entered", "1");
        gate.classList.add("is-exiting");
        storefront.classList.add("is-entered");
        storefront.setAttribute("aria-hidden", "false");
        document.body.classList.remove("gate-active");
        window.setTimeout(() => gate.remove(), prefersReduced ? 0 : 800);
      }, { once: true });
    }
  }

  const logo = document.querySelector("[data-logo-3d]");
  if (logo && window.matchMedia("(pointer:fine)").matches) {
    let targetX = 0, targetY = 0, x = 0, y = 0;
    const stage = logo.closest(".logo-stage");
    stage?.addEventListener("pointermove", e => {
      const r = stage.getBoundingClientRect();
      targetY = ((e.clientX - r.left) / r.width - .5) * 18;
      targetX = ((e.clientY - r.top) / r.height - .5) * -8;
    });
    stage?.addEventListener("pointerleave", () => { targetX = 0; targetY = 0; });
    const tick = () => {
      x += (targetX - x) * .06; y += (targetY - y) * .06;
      logo.style.setProperty("--mx", `${x}deg`);
      logo.style.setProperty("--my", `${y}deg`);
      requestAnimationFrame(tick);
    };
    tick();
  }
});
